import { useGtm } from '@gtm-support/vue-gtm';
import { AnalyticsAction, AnalyticsCategory } from '@/types/enums/analytics.enum';
import AnalyticsInterface from '@/types/interface/analytics.interface';

class Analytics implements AnalyticsInterface {
  private _action: AnalyticsAction;
  private _category: AnalyticsCategory;
  private _label: string;
  private _value: number;

  action(action: AnalyticsAction): Analytics {
    this._action = action;
    return this;
  }

  category(category: AnalyticsCategory): Analytics {
    this._category = category;
    return this;
  }

  label(label: string): Analytics {
    this._label = label;
    return this;
  }

  value(value: number): Analytics {
    this._value = value;
    return this;
  }

  track(): void {
    const gtm = useGtm();

    if (!gtm) {
      return;
    }

    gtm.trackEvent({
      event: 'interaction',
      action: this._action,
      label: this._label,
      category: this._category,
      value: this?._value,
    });
  }
}

const createEvent = (): AnalyticsInterface => {
  return new Analytics();
};

const enable = () => {
  const gtm = useGtm();

  gtm.enable(true);
};

const disable = () => {
  const gtm = useGtm();

  gtm.enable(false);
};

export default () => ({
  enable,
  disable,
  createEvent,
});
